import { useDispatch } from "react-redux";
import { setRecaptchaToken } from "../../subscription/actions";

export default function useRecaptcha() {
	const dispatch = useDispatch();

	const onSetRecaptchaToken = (token) => {
		dispatch(setRecaptchaToken(token));
	};

	return { onSetRecaptchaToken };
}
